import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { finalize, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoadingService } from '../../services/loading.service';

/**
 * HTTP interceptor to trigger loading bar
 * interceptor listens on any requested ressource
 * when it matches one of the environment api endpoints
 * it triggers loading via {@link LoadingService}
 *
 * @class LoadingInterceptor
 * @typedef {LoadingInterceptor}
 * @implements {HttpInterceptor}
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    /** injects {@link LoadingService} to receive and update laoding signal */
    #loadingService = inject( LoadingService );

    /**
     * when the request ends loading is switched off by default
     * @param {HttpRequest<any>} request any request made from within the app
     * @param {HttpHandler} next the http event stream which is handled
     * @returns {*} whatever was requested is returned
     */
    intercept( request: HttpRequest<any>, next: HttpHandler ) {
        const apiEndpoints = Object.values( environment.api );
        const endpointMatch = apiEndpoints.find( ( res ) => request.url.includes( res ) );

        return next.handle( request ).pipe(
            tap( () => this.#loadingService.setLoading( endpointMatch !== undefined ) ),
            finalize( () => this.#loadingService.setLoading() )
        );
    }
}
